import styled, { css } from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

interface IMenuItemProps {
    withDropDown: boolean,
    isCollapsed: boolean,
}

export const MenuItemWrapper = styled.li<IMenuItemProps>`
    position: relative;
    display: flex;
    margin-right: 24px;
    z-index: 1;

    &:hover {
        & > a,
        & > div {
            color: ${COLORS.TextPrimary};
        }

        &:after {
            background-color: ${COLORS.Control};
        }
    }

    ${({ withDropDown, isCollapsed }) => withDropDown && css`
        padding-right: 16px;
        z-index: ${isCollapsed ? 5 : 1};

        & > a,
        & > div {
            color: ${isCollapsed ? COLORS.TextPrimary : COLORS.TextHint};
        }

        &:after {
            content: '';
            position: absolute;
            top: 50%;
            right: 0;
            width: 8px;
            height: 5px;
            background-color: ${isCollapsed ? COLORS.Control : COLORS.GRAY_DARK};
            mask-image: url('/static/images/icons/arrow_down_fill_2.svg');
            mask-size: contain;
            mask-position: center;
            mask-repeat: no-repeat;
            transform-origin: center;
            transform: ${isCollapsed ? 'translateY(-50%) rotate(-180deg)' : 'translateY(-50%)'};
            transition: all .25s;
            cursor: pointer;
        }
    `}
`;

export const ItemText = styled.div`
    position: relative;
    ${FONTS.MediumXXS};
    text-decoration: none;
    transition: color .25s;
    cursor: pointer;
    z-index: 0;
`;

export const ItemLink = styled.a`
    ${FONTS.MediumXXS};
    text-decoration: none;
    transition: color .25s;
`;

export const Ul = styled.ul`
    display: flex;
    gap: 8px;
    flex-direction: column;
    align-items: flex-start;
`;

export const DropDownLink = styled.a`
    ${FONTS.MediumXS};
    color: ${COLORS.TextPrimary};
    text-decoration: none;
    white-space: nowrap;
    cursor: pointer;

    &:hover {
        color: ${COLORS.TextHint};
    }
`;
